module.exports = __webpack_public_path__ + "static/img/empty_1.7bdf162a.png";